import React, {Component} from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import MainLayout from '../CommonControlls/MainLayout';
import Topmenu from '../CommonControlls/Topmenubar';
import {connect} from 'react-redux'
import {Link} from 'react-router-dom';
import {SelectProvince} from '../OfflineDb/IndexDbTranscSP'
import AlertModal from '../CommonControlls/AlertModal';
import {SyncConfig} from '../OfflineDb/ConfigDataSync'
import DropDown from '../CommonControlls/DropdownRendrer'


const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({type: "UpdateAlert", payload: Settings})
        },
        ShowLoader: (Isloading) => {
            dispatch({type: "UpdateLoader", payload: Isloading})
        },
    }
}

class Province_Add extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Id: 0,

            permissions: [],

            alertModalData: {
                title: "",
                message: "",
                First_Callback: () => {
                },
                Second_Callback: () => {
                },
                type: 1,
            },

        };
    }

    render() {

        return (

            <div>
                <AlertModal  {...this.state.alertModalData} />
                <MainLayout/>
                <div id="right-panel" class="right-panel">
                    <Topmenu PageTitle={this.state.Id == 0 ? "Add Province" : "Edit Province"} isShowAddBtn={false}/>
                    <div class="content">

                        {/* <div class="PageHeader_Container">
                <h2>{this.state.Id==0?"Add Province":"Edit Province"}</h2>
            </div> */}

                        <div class="card col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div class="card-body">
                                <form onSubmit={this.SubmitForm} novalidate>

                                    <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label for=""><span style={{color: "red"}}>* </span>Province Name</label>
                                        <input autocomplete="off" type="text" class="form-control" id="ProvinceName"
                                               placeholder="Enter province name" required/>
                                    </div>

                                    <div
                                        class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <button type="submit" id="Form_SaveBtn" class="btn btn_style1">Save</button>
                                        <button type="button" id="Form_DeleteBtn" onClick={this.onDelete}
                                                hidden={this.state.Id === 0} class="btn btn_style2">Delete
                                        </button>
                                        <Link to="/Province">
                                            <button type="button" id="Form_CancelBtn" class="btn btn_style3">Cancel
                                            </button>
                                        </Link>

                                        {/* Hide button for reset */}
                                        <Link style={{display: "none"}} to="/Province_Add">
                                            <button id="Form_ResetBtn" type="button"
                                                    class="btn initial-btn Cancel-Form-btn Form_Btn">Reset
                                            </button>
                                        </Link>

                                    </div>

                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        )
    }

    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login")
        }
    }

    componentDidMount() {
        Common.AddClassToMenueLink("MenuLink_Province", true, "MenuParentLink_Geography")
        // Common.AddClassToMenueLink("MenuLink_Districts")
        var Id = Common.GetId()
        if (Id !== 0) {
            this.selectProvinceDetails(Id)
        }

        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.SelectAll_RolesPermissions, {
            pageSize: 15,
            pageNumber: 1
        }, (resp) => {
            console.log('resp', resp)
            const modifiedPermissions = resp.data.filter(p => p.permissioN_GROUP === 'Geography' && p.permissioN_ALLOWED).map(d => d.permissioN_NAME)
            this.setState({permissions: modifiedPermissions})
        })
    }

    selectProvinceDetails = (Id) => {
        this.props.ShowLoader({Isloading: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_Province,{},  (resp) => {
            this.props.ShowLoader({Isloading: false})
            if (resp.status) {
                const selected = resp.data.find(item => item.id === Id)
                this.LoadDataInEditMode(selected)
                // setTimeout(() => {
                //     $("#Alertmsgbtn").click()
                // }, 50);
                // $("#Form_CancelBtn").click()
            }
        }, (error) => {
            this.props.ShowLoader({Isloading: false})
            this.props.ShowAlert({Type: 0, Msg: error})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
        })
    }
    LoadDataInEditMode = (data) => {
        this.setState({
            Id: data.id,
            SrId: data.srid
        })
        $("#ProvinceName").val(data.name)
    }
    ResetForm = () => {
        this.setState({
            Id: 0,
        })
        $("#ProvinceName").val("")
    }
    SubmitForm = (e) => {
        e.preventDefault()
        this.props.ShowLoader({Isloading: true})
        var Parameters = {
            id: this.state.Id,
            name: $("#ProvinceName").val(),
        }
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Post", false,
            this.state.Id === 0 ? Common.APILinks.Save_Province : Common.APILinks.Update_Province, JSON.stringify(Parameters), (resp) => {
                if (resp.status) {
                    SyncConfig(() => {
                            if (this.state.Id !== 0)
                                $("#Form_ResetBtn").click()
                            this.ResetForm()
                            this.props.ShowLoader({Isloading: false})
                            this.props.ShowAlert({Type: 1, Msg: "Saved successfully"})
                            setTimeout(() => {
                                $("#Alertmsgbtn").click()
                            }, 50);
                        },
                        () => {
                            if (this.state.Id !== 0)
                                $("#Form_ResetBtn").click()
                            this.ResetForm()
                            this.props.ShowLoader({Isloading: false})
                            this.props.ShowAlert({Type: 0, Msg: "Error in sync, please reload the page"})
                            setTimeout(function () {
                                $("#Alertmsgbtn").click()
                            }, 50);
                        })
                } else {
                    this.props.ShowLoader({Isloading: false})
                    this.props.ShowAlert({Type: 0, Msg: resp.message})
                    setTimeout(() => {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({Isloading: false})
                this.props.ShowAlert({Type: 0, Msg: "Something went wrong, please try again."})
                setTimeout(() => {
                    $("#Alertmsgbtn").click()
                }, 50);
            })

    }
    onDelete = () => {
        this.setState({
            alertModalData: {
                title: "Delete Province",
                message: "Are you sure you want to delete this record.",
                First_Callback: () => {
                    $("#Generic-modal-CloseBtn").click();
                    this.DeleteRecord()
                },
                Second_Callback: () => {
                    $("#Generic-modal-CloseBtn").click()
                },
                type: 1,
            }
        }, () => {
            $("#Show_ArletModal").click()
        })
    }
    DeleteRecord = () => {
        this.props.ShowLoader({Isloading: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.Delete_Province, {Id: this.state.Id},
            (Result) => {
                if (Result.status == true) {
                    SyncConfig(() => {
                        $("#Form_CancelBtn").click()
                        this.props.ShowLoader({Isloading: false})
                        this.props.ShowAlert({Type: 1, Msg: "Deleted Successfully."})
                        setTimeout(function () {
                            $("#Alertmsgbtn").click()
                        }, 50);
                    }, () => {
                        this.props.ShowLoader({Isloading: false})
                        this.props.ShowAlert({Type: 0, Msg: "Error in sync, please reload the page"})
                        setTimeout(function () {
                            $("#Alertmsgbtn").click()
                        }, 50);
                    })
                } else {
                    this.props.ShowLoader({Isloading: false})
                    this.props.ShowAlert({Type: 0, Msg: Result.message})
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({Isloading: false})
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again."})
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            })
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(Province_Add);
